import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8ab4ba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-permissions-container" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "title-wrapper" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "접근 권한 허용이 필요합니다.", -1 /* HOISTED */))
const _hoisted_6 = {
  key: 0,
  class: "permission-section required"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-title" }, "필수 권한", -1 /* HOISTED */))
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "description" }
const _hoisted_10 = {
  key: 1,
  class: "permission-section option"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-title" }, "선택 권한", -1 /* HOISTED */))
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "description" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "horizontal-bar" }, null, -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailed-info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info-wrapper" }, [
    /*#__PURE__*/_createElementVNode("p", null, "*"),
    /*#__PURE__*/_createElementVNode("p", null, " 선택 권한은 해당 기능을 사용할 때 허용이 필요하며, 허용하지 않아도 해당 기능 외 서비스 이용이 가능합니다. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "info-wrapper" }, [
    /*#__PURE__*/_createElementVNode("p", null, "*"),
    /*#__PURE__*/_createElementVNode("p", null, "권한 허용 여부는 설정에서 변경할 수 있습니다.")
  ])
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString($setup.serviceInfo?.name ?? "통근버스") + " 이용을 위해", 1 /* TEXT */),
        _hoisted_5
      ]),
      ($setup.requiredPermissions.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.requiredPermissions, (permission, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "permission-wrapper",
                key: index
              }, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(permission.name), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_9, _toDisplayString(permission.description), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.optionPermissions.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.optionPermissions, (permission, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "permission-wrapper",
                key: index
              }, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(permission.name), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_13, _toDisplayString(permission.description), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      _hoisted_14,
      _hoisted_15
    ]),
    _createVNode($setup["FooterButton"], {
      title: "확인",
      onOnClickFooterButton: $setup.closeAppPermissionsModal
    })
  ]))
}